function loadImage(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve();
    image.onerror = () => reject(new Error(`Favicon ${src} did not load; keeping the production icons`));
    image.src = src;
  });
}

/**
 * Testers tell builds apart by the tab icon. The production icons index.html links stay unless the build
 * declares a set and every icon in it loads, so a broken or partial set can never blank or mix the tab icon.
 */
export async function applyEnvironmentFavicon(set: string | null, doc: Document = document, load = loadImage): Promise<void> {
  if (!set) {
    return;
  }
  const swaps = Array.from(doc.querySelectorAll<HTMLLinkElement>('link[rel~="icon"]'))
    .map(link => ({ link, href: `assets/favicons/${set}/${link.href.split('/').pop()}` }));
  await Promise.all(swaps.map(swap => load(swap.href)));
  swaps.forEach(swap => swap.link.setAttribute('href', swap.href));
}
